
























































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import EventBus from '@/plugins/EventBus'
import { maskDate } from '@/utils/common'
import RecebimentoStore from '@/components/Recebimento/Store/RecebimentoStore'
import ModalAddTabelaOperadora from './ModalAddTabelaOperadora.vue'

@Component({
  components: {
    ModalAddTabelaOperadora,
  },
})
export default class ModalTabelaOperadora extends Vue {
  readyState: boolean = false
  loadOperadoras: boolean = false
  loadAddOperadora: boolean = false
  loadDeleteOperadora: string = ''
  operadoraSearch: string = ''

  get getRecebimentoStore() { return getModule(RecebimentoStore, this.$store) }

  get getOperadoras() { return this.getRecebimentoStore.tabelaOperadoras }

  get loadingShowModalAddTabelaOperadora() { return this.loadAddOperadora }
  set loadingShowModalAddTabelaOperadora(value: boolean) { this.loadAddOperadora = value }

  get loadingDeleteOperadora() { return this.loadDeleteOperadora }
  set loadingDeleteOperadora(value: string) { this.loadDeleteOperadora = value }

  get loadingOperadoras() { return this.loadOperadoras }
  set loadingOperadoras(value: boolean) { this.loadOperadoras = value }

  get getHeaders() {
    return [
      { text: 'Nome', class: 'table-headers', align: 'left', value: 'nomeOperadora' },
      { text: 'Criado por', class: 'table-headers', align: 'left', value: 'criadoPor' },
      { text: 'Criado em', class: 'table-headers', align: 'left', value: 'criadoEm' },
      { text: 'Ações', class: 'table-headers', value: '', align: 'center', sortable: false },
    ]
  }

  get showModalOperadoras() {
    return this.getRecebimentoStore.modalTabelaOperadora
  }

  set showModalOperadoras(value: boolean) {
    this.getRecebimentoStore.setModalTabelaOperadora(value)
  }

  maskDate(date: string) {
    return maskDate(date)
  }

  async showModalAddTabelaOperadoras() {
    this.loadingShowModalAddTabelaOperadora = true
    await this.getRecebimentoStore.getOperadoras()
    this.getRecebimentoStore.setModalAddTabelaOperadora(true)
    this.loadingShowModalAddTabelaOperadora = false
  }

  async deletarPrestador(id: any) {
    this.loadingDeleteOperadora = id
    const request = await this.getRecebimentoStore.deleteTabelaOperadora(id)
    if (request.success) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: 'Prestador removido com sucesso!',
        icon: 'check',
        color: '#43A047',
      })
      this.loadingDeleteOperadora = ''
      this.getRecebimentoStore.getTabelaOperadora(this.getRecebimentoStore.tabelaPrecoId)
      return
    }
    EventBus.$emit('setSnackbar', {
      show: true,
      text: `${request.message} ${String.fromCodePoint(0x1F615)}`,
      icon: 'warning',
      color: '#C62828',
    })
    this.loadingDeleteOperadora = ''
  }

  @Watch('showModalOperadoras')
  onChangeShowModalOperadora(value: boolean) {
    if (!value) {
      this.operadoraSearch = ''
    }
  }
}
